export default {
  'call-dispatcher': 'Gọi điều phối viên',
  'error-code': 'Lỗi {code}',
  'dispatcher-hint': 'Nếu bạn thấy lỗi này, vui lòng liên hệ điều phối viên Rx2Go',
  400: {
    title: 'Yêu cầu không hợp lệ',
    description: 'Có vẻ như liên kết bạn nhấp có vấn đề nhỏ, vì vậy chúng tôi không thể xử lý yêu cầu của bạn.',
  },
  404: {
    title: 'Không tìm thấy',
    description: 'Trang bạn đang tìm kiếm có thể đã bị xóa, đã thay đổi tên hoặc tạm thờ không khả dụng.',
  },
  500: {
    title: 'Lỗi máy chủ nội bộ',
    description: 'Chúng tôi đã gặp lỗi không mong muốn. Vui lòng thử lại sau.',
  },
  generic: {
    title: 'Đã xảy ra lỗi',
    description: 'Đã xảy ra lỗi',
  },
}
